import { transform } from 'lodash';
import googleFonts from './googleFonts.json'; // generated from https://developers.google.com/fonts/docs/developer_api
import { addOrMoveToStart, generateGoogleFontUrl } from './helpers';

export const fontFamilies = {
	serif: [
		'ui-serif',
		'Georgia',
		'Cambria',
		'Times New Roman',
		'Times',
		'serif'
	],
	'sans-serif': [
		'ui-sans-serif',
		'system-ui',
		'-apple-system',
		'BlinkMacSystemFont',
		'Segoe UI',
		'Roboto',
		'Helvetica Neue',
		'Arial',
		'Noto Sans',
		'sans-serif',
		'Apple Color Emoji',
		'Segoe UI Emoji',
		'Segoe UI Symbol',
		'Noto Color Emoji'
	],
	monospace: [
		'ui-monospace',
		'SFMono-Regular',
		'Menlo',
		'Monaco',
		'Consolas',
		'Liberation Mono',
		'Courier New',
		'monospace'
	],
	handwriting: ['Brush Script MT', 'Comic Sans MS', 'Bradley Hand']
};

export const typographyVariantNames = [
	'h1',
	'h2',
	'h3',
	'subtitle1',
	'subtitle2',
	'body1',
	'body2'
];

export const componentVariantNames = ['input', 'button'];

export const variantNamesOrder = [
	...typographyVariantNames,
	...componentVariantNames
];

export const FONT_WEIGHTS = {
	'100': 'Thin',
	'200': 'Extra Light',
	'300': 'Light',
	'400': 'Normal',
	'500': 'Medium',
	'600': 'Semi Bold',
	'700': 'Bold',
	'800': 'Extra Bold',
	'900': 'Black'
};

export const FONT_FAMILIES = transform(
	googleFonts,
	(result, value) =>
		result.push({
			label: value.family,
			family: addOrMoveToStart(
				value.family,
				fontFamilies[value.category as keyof typeof fontFamilies] ||
					fontFamilies['sans-serif']
			),
			url: generateGoogleFontUrl(value.family)
		}),
	[
		{
			label: 'Sans Serif',
			family: fontFamilies['sans-serif']
		},
		{
			label: 'Arial',
			family: addOrMoveToStart('Arial', fontFamilies['sans-serif'])
		},
		{
			label: 'Comic Sans MS',
			family: addOrMoveToStart('Comic Sans MS', fontFamilies.handwriting)
		},
		{
			label: 'Courier New',
			family: addOrMoveToStart('Courier New', fontFamilies.monospace)
		},
		{
			label: 'Georgia',
			family: addOrMoveToStart('Georgia', fontFamilies.serif)
		},
		{
			label: 'Impact',
			family: addOrMoveToStart('Impact', fontFamilies['sans-serif'])
		},
		{
			label: 'Times New Roman',
			family: addOrMoveToStart('Times New Roman', fontFamilies.serif)
		},
		{
			label: 'Verdana',
			family: addOrMoveToStart('Verdana', fontFamilies['sans-serif'])
		}
	] as { label: string; family: string[]; url: string }[]
);

export const FONT_SIZES = [
	'8',
	'9',
	'10',
	'11',
	'12',
	'14',
	'18',
	'24',
	'30',
	'48',
	'60',
	'72',
	'96'
];

export const FONT_SIZE_LIMIT = 256;
